import { Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { message } from "antd";
import LicenseOrderKeys from "./license-order-keys";
import LicenseOrderMain from "./license-order-main";

const LicenseOrder = ({ companyId, accId, onClose }) => {
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    if (!companyId || !accId) return;

    setLoading(true);
    serverFetch(`license/order?companyId=${companyId}&accId=${accId}`)
      .then((data) => {
        setLoading(false);
        setOrderData(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (companyId && accId) {
      getData();
    }
  }, [companyId, accId]);

  const handleOrderUpdate = (updatedData) => {
    setOrderData(updatedData);
  };

  const handleClose = (refresh) => {
    onClose(refresh);
  };

  return (
    <>
      <div
        className="cloud-modal-overlay"
        onClick={() => handleClose(false)}
      />
      <div className="cloud-modal-license-order-keys">
        <div className="cloud-modal-header">
          <h3>Заказ лицензии #{companyId} / {accId}</h3>
          <Button onClick={() => handleClose(false)} type="text">×</Button>
        </div>
        <div className="cloud-modal-content">
          <Tabs
            items={
              accId === 0
                ? [
                    {
                      key: 'order',
                      label: 'Заказ',
                      children: (
                        <LicenseOrderMain
                          companyId={companyId}
                          accId={accId}
                          onUpdate={handleOrderUpdate}
                          onClose={handleClose}
                        />
                      ),
                    },
                  ]
                : [
                    {
                      key: 'order',
                      label: 'Заказ',
                      children: (
                        <LicenseOrderMain
                          companyId={companyId}
                          accId={accId}
                          onUpdate={handleOrderUpdate}
                          onClose={handleClose}
                        />
                      ),
                    },
                    {
                      key: 'keys',
                      label: 'Ключи',
                      children: (
                        <LicenseOrderKeys
                          companyId={companyId}
                          accId={accId}
                          onClose={() => {}} // Не закрываем модальное окно при закрытии ключей
                        />
                      ),
                    },
                  ]
            }
            type="card"
          />
        </div>
      </div>
    </>
  );
};

export default LicenseOrder;
